import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-top">
          <div className="footer-brand">
            <h4>Daksh Ravitaj</h4>
            <p>Your trusted partner in Ayurvedic exports</p>
          </div>
          <div className="footer-links">
            <h4>Quick Links</h4>
            <nav>
              <a href="#home">Home</a>
              <a href="#about">About</a>
              <a href="#products">Products</a>
              <a href="#process">Process</a>
              <a href="#contact">Contact</a>
            </nav>
          </div>
          <div className="footer-contact">
            <h4>Contact Us</h4>
            <p>Email: <a href="mailto:info@ravitaj.com">info@ravitaj.com</a></p>
            <p>Phone: <a href="tel:+919624797077">+91 9624797077</a></p>
            <p>Location: Ahmedabad, Gujarat, India - 380060</p>
          </div>
          <div className="footer-social">
            <h4>Follow Us</h4>
            <div className="social-icons">
              <a href="https://www.linkedin.com/in/ravitaj-exim-a9544636a" target="_blank" rel="noopener noreferrer">LinkedIn</a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Daksh Ravitaj. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
